import CustomAsyncSelect from "../CustomAsyncSelect";

const ProductSelect = ({
    label,
    description,
    placeholder = "Search and select products...",
    value = [],
    onChange,
    name = "products",
    className,
    containerClass,
    ...props
}) => {
    // Transform API data to select options
    const transformData = (product) => ({
        value: product.id,
        label: product.name,
        image: product.images?.[0]?.src || "",
        imageAlt: product.images?.[0]?.alt || product.name,
    });

    // Format option label with product thumbnail and ID
    // context can be 'menu' (dropdown) or 'value' (selected items)
    const formatOptionLabel = (option, { context }) => {
        // For selected items (pills) - compact format without image
        if (context === "value") {
            return (
                <div className="flex items-center gap-2 justify-between w-full py-[0.20rem]">
                    <span className="text-xs font-medium text-gray-500">
                        #{option.value}
                    </span>
                    <span className="text-sm text-gray-900 truncate">
                        {option.label}
                    </span>
                </div>
            );
        }

        // For dropdown menu - show image, ID, and name
        return (
            <div className="flex items-center gap-3 w-full">
                {/* Product Thumbnail */}
                {option.image ? (
                    <img
                        src={option.image}
                        alt={option.imageAlt}
                        className="w-10 h-10 rounded object-cover flex-shrink-0 border border-gray-200"
                    />
                ) : (
                    <div className="w-10 h-10 rounded bg-gray-100 flex items-center justify-center flex-shrink-0 border border-gray-200">
                        <svg
                            className="w-5 h-5 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                        </svg>
                    </div>
                )}

                {/* Product Info */}
                <div className="flex flex-col flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                        <span className="text-xs font-medium text-gray-500 flex-shrink-0">
                            #{option.value}
                        </span>
                        <span className="text-sm text-gray-900 truncate font-medium">
                            {option.label}
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <CustomAsyncSelect
            label={label}
            value={value}
            onChange={onChange}
            name={name}
            placeholder={placeholder}
            description={description}
            className={className}
            containerClass={containerClass}
            endpoint="wc/v3/products"
            transformData={transformData}
            formatOptionLabel={formatOptionLabel}
            searchParams={{
                orderby: "title",
                order: "asc",
                status: "publish",
            }}
            selectedLabel="Product"
            noOptionsText="Start typing to search products..."
            {...props}
        />
    );
};

export default ProductSelect;
